/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber, optional as codecOptional, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const ImportIntoAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['fromAssignmentId', codecNumber, 'from_assignment_id'],
    [
        'allowExistingSubmissions',
        /* #__PURE__ */ codecOptional(codecBoolean),
        'allow_existing_submissions',
    ],
]);
export class ImportIntoAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ImportIntoAssignmentDataParser.decode(input).map(res => new ImportIntoAssignmentData(res));
    }
    static unsafeDecode(input) {
        return ImportIntoAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ImportIntoAssignmentDataParser.encode(data);
    }
    static schema() {
        return ImportIntoAssignmentDataParser.schema();
    }
}
